import { UserServiceClientApi } from '../../services/api/UserApiServices';
import store from '../configureStore';
import { DOMAIN_RECEIVED, REMOVE_BOT, REMOVE_SELECTED_DOMAIN, SELECTED_BOT, SELECTED_DOMAIN, SET_DOMAIN_STATE } from '../constants';
import { fetchBotSubscriptions } from './user';
import { handleApiError } from '../../utils/general';
import { fetchContacts } from './contacts';
import { setHeaderTitle } from './layout';
import { saveInLocalStorage } from '../../services/storage/LocalStorage';
import { LFStorageKeys } from '../../services/storage/LFStorage';
import { setTabState } from './tabStack';
import { setInitializeDefaultHomePageBot, setShowDefaultHomepageBot } from './bot';


export const removeSelectedDomain = () => ({
    type: REMOVE_SELECTED_DOMAIN,
});


export const getUserDomainList = async () => {
    try {
        const response = await UserServiceClientApi.getUserDomainsList();
        if (response?.status === 200 && response.data?.domains) {
            let filteredDomains = response.data.domains;
            store.dispatch({
                type: DOMAIN_RECEIVED,
                payload: { domains: filteredDomains },
            });

            return filteredDomains
        }
    } catch (error) {
        console.error("Error fetching user domains:", error);
        // handleApiError(error);
    };
};

export const setSelectedDomain = (domainData) => async (dispatch, getState) => {
    if (!domainData) return;
   const urlParams = new URLSearchParams(window.location.search);
   const botIdFromUrl = urlParams.get("botId");
    const initializeDefaultHomePage = getState().bot.initializeDefaultHomePage;

    console.log("%c Current Domain:", "color: green", domainData);
    await getUserDomainList();
    dispatch(fetchBotSubscriptions(domainData, null, false, true, ''));
    saveInLocalStorage(LFStorageKeys.SELECTED_DOMAIN, domainData.name)
    dispatch(setTabState(true));

    if (window.location.pathname.includes('contacts')) {
        dispatch(setDomainState(false))
        dispatch(setTabState(true))
        await dispatch(fetchContacts({ selectedDomain: domainData?.userDomain }, true))
    }

    dispatch(removeSelectedDomain());
    dispatch({
        type: SELECTED_DOMAIN,
        payload: {
            selectedDomain: domainData.userDomain,
            selectedDomainDetails: domainData,
            defaultHomePageBotId: domainData.defaultHomePageBotId ?? ""
        },
    });
    if (!domainData.landingBotId && !initializeDefaultHomePage && !botIdFromUrl) {
        dispatch(setInitializeDefaultHomePageBot());
        dispatch(setShowDefaultHomepageBot());

        dispatch(setHeaderTitle("Home"));
    }else if(initializeDefaultHomePage && !domainData.landingBotId && window.location.pathname.includes('chats') && !botIdFromUrl){
         dispatch(setInitializeDefaultHomePageBot());
        dispatch(setShowDefaultHomepageBot());
        dispatch(setHeaderTitle("Home"));
    }
};


export const setSelectedBot = (botData) => async (dispatch, getState) => {
    if (!botData) return;
    const isDefaultHomePageBot = getState().bot.isDefaultHomePageBot;

    dispatch(setTabState(true));

    dispatch({
        type: SELECTED_BOT,
        payload: {
            selectedBotId: botData.botId,
            selectedBotDetails: botData,
        },
    });

    if (window.location.pathname.includes("chats") && !isDefaultHomePageBot) {
        dispatch(setHeaderTitle(botData?.botName));
    }
};


export const setDomainState = (data) => async (dispatch) => {
    dispatch({
        type: SET_DOMAIN_STATE,
        payload: { domainState: data },
    });

};

export const removeBot = () => async (dispatch) => {
    dispatch({
        type: REMOVE_BOT,
        payload: { selectedBotId: null, selectedBotDetails: null },
    });
};